export * from './types.js';

import { authApi } from './domains/auth.js';
import { discordApi } from './domains/discord.js';
import { healthApi } from './domains/health.js';
import { llmApi } from './domains/llm.js';
import { permissionsApi } from './domains/permissions.js';
import { dungeonApi, dungeonUiApi } from './domains/dungeon.js';
import { hotelBullApi } from './domains/hotel-bull.js';
import { visionApi } from './domains/vision.js';
import { praiseKinkApi } from './domains/praise-kink.js';
import { conversationsApi } from './domains/conversations.js';

export const coreServicesApi = {
  discord: discordApi,
  auth: authApi,
  health: healthApi,
  llm: llmApi,
  permissions: permissionsApi,
  dungeon: dungeonApi,
  dungeonUi: dungeonUiApi,
  hotelBull: hotelBullApi,
  vision: visionApi,
  praiseKink: praiseKinkApi,
  conversations: conversationsApi,
};

export default coreServicesApi;

export {
  authApi,
  discordApi,
  healthApi,
  llmApi,
  permissionsApi,
  dungeonApi,
  dungeonUiApi,
  hotelBullApi,
  visionApi,
  praiseKinkApi,
  conversationsApi,
};
